import { render, staticRenderFns } from "./Clip.vue?vue&type=template&id=68983a49&"
import script from "./Clip.vue?vue&type=script&lang=js&"
export * from "./Clip.vue?vue&type=script&lang=js&"
import style0 from "./Clip.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports